import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Card from "../components/card"
import PageTitle from "../components/pageTitle"
import SectionTitle from "../components/sectionTitle"
import Container from "../components/container"
import CdpFooter from "../components/cdp-footer"
import StaticTagList from "../components/staticTagList"
import Sidebar from "../components/sidebar"
import Pagination from "../components/pagination"
import AdtechplatformFeaturedPosts from "../components/adtechplatformFeaturedPosts"
import CdpFeaturedPosts from "../components/cdpFeaturedPosts"
import CasesFilter from "../components/casesFilter"

const TagTemplate = ({ pageContext, data, location }) => {
  const { totalCount } = data.allMarkdownRemark
  const posts = data.allMarkdownRemark.nodes

  return (
    <Layout location={location}>
      <Seo
        title={`${
          pageContext.currentPage !== 1
            ? `${pageContext.currentPage}ページ目｜`
            : ``
        }${pageContext.metaData.title}の記事一覧`}
        description={pageContext.metaData.description}
      />
      <PageTitle
        title={pageContext.metaData.title}
        description={pageContext.metaData.description}
      />
      {pageContext.tag === "cdp" ? (
        <CdpFeaturedPosts />
          ) : pageContext.tag === "ad-tech-platform" ? (
        <AdtechplatformFeaturedPosts />
          ) : null}
      <Container className="lg:flex justify-between mt-6 lg:mt-12 mb-6 lg:mb-12">
        <div className="lg:w-2/3">
          <SectionTitle title="記事一覧" bgText="Articles" className="mb-6" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7">
          {posts.map(post => {
  const linkedPost = {
    ...post,
    fields: {
      ...post.fields,
      meta: {
        ...post.fields.meta,
        slug: post.frontmatter.redirectTo || post.fields.meta.slug,
      },
    },
  }

  return (
    <Card
      post={linkedPost}
      size="m"
      key={`${pageContext.tag}-${post.id}`}
    />
  )
})}
          </div>
          <div className="pt-14">
            <Pagination
              numPages={pageContext.numPages}
              currentPage={pageContext.currentPage}
              pageLimit={5}
              pagingPath={`/tag/${pageContext.tag}/`}
              hasRootUrl={true}
            />
          </div>
        </div>
        <div className="lg:w-1/4">
          <Sidebar
            banner={
              pageContext.tag === "cdp"
                ? [1]
                : pageContext.tag === "ad-tech-platform"
                ? [2]
                : pageContext.metaData.type === "others"
                ? []
                : null
            }
          >
            {pageContext.tag === "cases" && <CasesFilter />}
            {pageContext.tag !== "cases" &&
              pageContext.tag !== "cdp" &&
              pageContext.tag !== "ad-tech-platform" &&
              pageContext.metaData.type !== "others" && (
                <StaticTagList
                  tagType={pageContext.metaData.type}
                  className="mb-4 lg:mb-7"
                  headingText="一覧"
                />
              )}
          </Sidebar>
        </div>
      </Container>
      {pageContext.tag === "cdp" ? <CdpFooter /> : null}
    </Layout>
  )
}

export default TagTemplate

export const pageQuery = graphql`
  query ($tag: String, $skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      limit: $limit
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { tags: { in: [$tag] } }
        fields: { meta: { draft: { eq: false } } }
      }
      skip: $skip
    ) {
      totalCount
      nodes {
        fields {
          meta {
            slug
          }
        }
        frontmatter {
          date(formatString: "YYYY.MM.DD")
          title
          description
          tags
          redirectTo
          cover {
            childImageSharp {
              gatsbyImageData(width: 800, formats: AUTO)
            }
          }
        }
        id
      }
    }
  }
`
